// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"styles_wrapper__1TIQO","content":"styles_content__2sqE1","learnMore":"styles_learnMore__3aIVY","trigger":"styles_trigger__2pUAU"};